export default {
  en: {
    'match_report': 'match report',
    'red': 'red',
    'yellow': 'yellow',
    'yellow_red': 'yellow red',
    'own_goal': 'own goal',
    'goal': 'goal',
    'in': 'in',
    'out': 'out',
    'start_regular_time': 'start',
    'end_regular_time': 'end regular time',
    'start_extra_time': 'start extra time',
    'end_extra_time': 'end extra time',
    'preparing...': 'preparing...',
    'not_all_linedup_players_are_able_to_player_this_match': 'Not all linedup players are able to player this match!',
    'invalid_lineup': 'invalid lineup',
    'ready': 'ready',
    'starting_match': 'Starting match...',
    'speed': 'speed',
    'incidents': 'incidents',
    'x_substitutions_left': '{x} substitutions left',
    'too_many_substitutions': 'Too many substitutions!',
    'pause': 'pause',
    'not_enough_players': 'Not enough players to start / continue the match.',
    'start_penalty': 'start penalty',
    'end_penalty': 'end penalty',
    'disable_incidents': 'disable incidents',
    'stats': 'stats',
    'chances': 'chances',
    'possession': 'possession',
    '': '',
  }
};